{
  "$defs": {
    "A2ASettings": {
      "additionalProperties": false,
      "properties": {
        "publish_card": {
          "default": false,
          "title": "Publish Card",
          "type": "boolean"
        },
        "skills": {
          "default": [],
          "items": {
            "$ref": "#/$defs/A2ASkill"
          },
          "title": "Skills",
          "type": "array"
        }
      },
      "title": "A2ASettings",
      "type": "object"
    },
    "A2ASkill": {
      "additionalProperties": false,
      "properties": {
        "description": {
          "$ref": "#/$defs/Text"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "name": {
          "$ref": "#/$defs/Text"
        },
        "tags": {
          "default": [],
          "items": {
            "type": "string"
          },
          "title": "Tags",
          "type": "array"
        }
      },
      "required": [
        "id",
        "name",
        "description"
      ],
      "title": "A2ASkill",
      "type": "object"
    },
    "ApprovalLevel": {
      "additionalProperties": false,
      "description": "One level of an approval chain (ADR-0102). Levels run in order; a level whose ``when``\nis false is skipped. The same person never signs two levels of one request, and never\ntheir own request.",
      "properties": {
        "approver_roles": {
          "default": [],
          "description": "approvers=roles: anyone holding one of these roles signs",
          "items": {
            "type": "string"
          },
          "maxItems": 20,
          "title": "Approver Roles",
          "type": "array"
        },
        "approvers": {
          "$ref": "#/$defs/ApproverKind",
          "default": "roles"
        },
        "escalate_to": {
          "default": [],
          "description": "Roles the level goes to, in order, when nobody decides in time (ADR-0097)",
          "items": {
            "type": "string"
          },
          "maxItems": 10,
          "title": "Escalate To",
          "type": "array"
        },
        "fallback_roles": {
          "default": [
            "approver"
          ],
          "description": "Who signs when the manager or the named person cannot be found",
          "items": {
            "type": "string"
          },
          "maxItems": 20,
          "minItems": 1,
          "title": "Fallback Roles",
          "type": "array"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name, e.g. 'Finance director'"
        },
        "manager_of": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "approvers=manager: a state path holding the username whose manager signs; unset: the manager of the person who started the run",
          "title": "Manager Of"
        },
        "person": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "approvers=person: a state path holding the signer's username",
          "title": "Person"
        },
        "quorum": {
          "default": 1,
          "description": "How many different people must approve (e.g. 2 of the role's holders)",
          "maximum": 10,
          "minimum": 1,
          "title": "Quorum",
          "type": "integer"
        },
        "sla": {
          "anyOf": [
            {
              "format": "duration",
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Time limit in working hours; unset: the rule's or step's",
          "title": "Sla"
        },
        "sla_days": {
          "anyOf": [
            {
              "maximum": 60,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Time limit in the organisation's working days (instead of sla)",
          "title": "Sla Days"
        },
        "when": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Condition on state; the level applies only when it is true",
          "title": "When"
        }
      },
      "title": "ApprovalLevel",
      "type": "object"
    },
    "ApprovalRule": {
      "additionalProperties": false,
      "description": "Spec-level approval rules can only add requirements on top of OPA obligations.\n\nEvery matching rule applies, in the order of the list (ADR-0102): their levels form one\napproval chain together with the platform's own requirement, without duplicates.",
      "properties": {
        "action": {
          "title": "Action",
          "type": "string"
        },
        "approver_roles": {
          "default": [
            "approver"
          ],
          "items": {
            "type": "string"
          },
          "title": "Approver Roles",
          "type": "array"
        },
        "escalate_to": {
          "default": [],
          "description": "Roles the request goes to, in order, when nobody decides within sla (a reminder half-way first; each role gets the same time again). ADR-0097",
          "items": {
            "type": "string"
          },
          "title": "Escalate To",
          "type": "array"
        },
        "levels": {
          "default": [],
          "description": "An approval chain (ADR-0102): levels signed in order. Unset: one level by approver_roles with sla and escalate_to",
          "items": {
            "$ref": "#/$defs/ApprovalLevel"
          },
          "title": "Levels",
          "type": "array"
        },
        "sla": {
          "default": "PT4H",
          "format": "duration",
          "title": "Sla",
          "type": "string"
        },
        "sla_days": {
          "anyOf": [
            {
              "maximum": 60,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Time limit in the organisation's working days (instead of sla)",
          "title": "Sla Days"
        },
        "tool": {
          "title": "Tool",
          "type": "string"
        },
        "when": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Condition expression on state",
          "title": "When"
        }
      },
      "required": [
        "tool",
        "action"
      ],
      "title": "ApprovalRule",
      "type": "object"
    },
    "ApproverKind": {
      "description": "Who signs one level of an approval chain (ADR-0102).",
      "enum": [
        "roles",
        "manager",
        "person"
      ],
      "title": "ApproverKind",
      "type": "string"
    },
    "AskPerson": {
      "additionalProperties": false,
      "description": "A person chooses among the same options; the model's suggestion and confidence are\nshown to them.",
      "properties": {
        "approver_roles": {
          "default": [
            "approver"
          ],
          "items": {
            "type": "string"
          },
          "minItems": 1,
          "title": "Approver Roles",
          "type": "array"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "sla": {
          "default": "PT4H",
          "format": "duration",
          "title": "Sla",
          "type": "string"
        }
      },
      "title": "AskPerson",
      "type": "object"
    },
    "Budgets": {
      "additionalProperties": false,
      "properties": {
        "max_cost_usd": {
          "default": 1.0,
          "exclusiveMinimum": 0,
          "maximum": 10000,
          "title": "Max Cost Usd",
          "type": "number"
        },
        "max_steps": {
          "default": 25,
          "maximum": 1000,
          "minimum": 1,
          "title": "Max Steps",
          "type": "integer"
        },
        "max_tokens": {
          "default": 100000,
          "minimum": 1,
          "title": "Max Tokens",
          "type": "integer"
        },
        "timeout": {
          "default": "PT10M",
          "format": "duration",
          "title": "Timeout",
          "type": "string"
        }
      },
      "title": "Budgets",
      "type": "object"
    },
    "BuilderProfile": {
      "enum": [
        "code",
        "nocode"
      ],
      "title": "BuilderProfile",
      "type": "string"
    },
    "Button": {
      "additionalProperties": false,
      "properties": {
        "action": {
          "default": {
            "type": "reply",
            "value": null
          },
          "discriminator": {
            "mapping": {
              "action": "#/$defs/StepAction",
              "handoff": "#/$defs/HandoffAction",
              "link": "#/$defs/LinkAction",
              "reply": "#/$defs/ReplyAction"
            },
            "propertyName": "type"
          },
          "oneOf": [
            {
              "$ref": "#/$defs/ReplyAction"
            },
            {
              "$ref": "#/$defs/LinkAction"
            },
            {
              "$ref": "#/$defs/StepAction"
            },
            {
              "$ref": "#/$defs/HandoffAction"
            }
          ],
          "title": "Action"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "$ref": "#/$defs/ReplyText"
        }
      },
      "required": [
        "id",
        "label"
      ],
      "title": "Button",
      "type": "object"
    },
    "ButtonsBlock": {
      "additionalProperties": false,
      "properties": {
        "buttons": {
          "items": {
            "$ref": "#/$defs/Button"
          },
          "maxItems": 10,
          "minItems": 1,
          "title": "Buttons",
          "type": "array"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "kind": {
          "const": "buttons",
          "default": "buttons",
          "title": "Kind",
          "type": "string"
        }
      },
      "required": [
        "id",
        "buttons"
      ],
      "title": "ButtonsBlock",
      "type": "object"
    },
    "CalcValue": {
      "additionalProperties": false,
      "description": "One value a \"Calculate\" step works out (ADR-0103).",
      "properties": {
        "expr": {
          "description": "The formula: state values, numbers, text, arithmetic and the expression functions (round, vat, within, add_working_days, to_hijri, concat, ...)",
          "maxLength": 2000,
          "minLength": 1,
          "title": "Expr",
          "type": "string"
        },
        "key": {
          "description": "State key the value is kept under, e.g. 'total_with_vat'",
          "title": "Key",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name, e.g. 'Total with VAT'"
        }
      },
      "required": [
        "key",
        "expr"
      ],
      "title": "CalcValue",
      "type": "object"
    },
    "CalculateNode": {
      "additionalProperties": false,
      "description": "Work values out without AI or code (ADR-0103): arithmetic, rounding, VAT, percentages,\ntolerances, date maths with working days and Hijri dates, text formatting, and setting or\ncopying values. Deterministic and side-effect free (risk tier 1); runs inside the step's\nactivity. Values are worked out in order, so a later one may use an earlier one.",
      "properties": {
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_error": {
          "anyOf": [
            {
              "enum": [
                "fail",
                "continue"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "A value that can't be worked out (e.g. a division by zero): 'fail' stops the run with the reason (the default); 'continue' keeps it empty and records the reason under <id>_problems.",
          "title": "On Error"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "type": {
          "const": "calculate",
          "default": "calculate",
          "title": "Type",
          "type": "string"
        },
        "values": {
          "items": {
            "$ref": "#/$defs/CalcValue"
          },
          "maxItems": 50,
          "minItems": 1,
          "title": "Values",
          "type": "array"
        }
      },
      "required": [
        "id",
        "values"
      ],
      "title": "CalculateNode",
      "type": "object"
    },
    "CardField": {
      "additionalProperties": false,
      "properties": {
        "label": {
          "$ref": "#/$defs/ReplyText"
        },
        "value": {
          "maxLength": 500,
          "minLength": 1,
          "title": "Value",
          "type": "string"
        }
      },
      "required": [
        "label",
        "value"
      ],
      "title": "CardField",
      "type": "object"
    },
    "CardsBlock": {
      "additionalProperties": false,
      "description": "One card per item of a list from earlier steps. Inside a card, ``{field}`` is the item's\nfield (``{item}`` the item itself); buttons may use the item too.",
      "properties": {
        "buttons": {
          "default": [],
          "items": {
            "$ref": "#/$defs/Button"
          },
          "maxItems": 4,
          "title": "Buttons",
          "type": "array"
        },
        "fields": {
          "default": [],
          "items": {
            "$ref": "#/$defs/CardField"
          },
          "maxItems": 8,
          "title": "Fields",
          "type": "array"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "image": {
          "anyOf": [
            {
              "maxLength": 2000,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Image"
        },
        "items": {
          "title": "Items",
          "type": "string"
        },
        "kind": {
          "const": "cards",
          "default": "cards",
          "title": "Kind",
          "type": "string"
        },
        "max": {
          "default": 10,
          "maximum": 20,
          "minimum": 1,
          "title": "Max",
          "type": "integer"
        },
        "subtitle": {
          "anyOf": [
            {
              "$ref": "#/$defs/ReplyText"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "title": {
          "$ref": "#/$defs/ReplyText"
        }
      },
      "required": [
        "id",
        "items",
        "title"
      ],
      "title": "CardsBlock",
      "type": "object"
    },
    "Channel": {
      "description": "Where people (or programs) reach the agent; a run started from a channel the agent does\nnot list is refused (ADR-0099). Names as the channels service uses them.",
      "enum": [
        "web",
        "api",
        "widget",
        "email",
        "voice",
        "chat",
        "mcp",
        "chat_app"
      ],
      "title": "Channel",
      "type": "string"
    },
    "Classification": {
      "enum": [
        "public",
        "internal",
        "confidential",
        "restricted"
      ],
      "title": "Classification",
      "type": "string"
    },
    "DecisionKind": {
      "enum": [
        "choice",
        "boolean",
        "score"
      ],
      "title": "DecisionKind",
      "type": "string"
    },
    "DecisionNode": {
      "additionalProperties": false,
      "description": "A typed control decision by the fast decision model (gateway ``/v1/decisions``,\nADR-0059): a choice among declared options, yes/no, or a rubric score, with a probability.\n\nEdges leaving a choice or yes/no decision use ``when: <option value>``; edges leaving a\nscore decision use ordinary conditions on ``state.<output_key>.value``.",
      "properties": {
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "input": {
          "default": "{{ state.question }}",
          "description": "What the model reads: text with {{ state.path }} templates",
          "maxLength": 2000,
          "minLength": 1,
          "title": "Input",
          "type": "string"
        },
        "kind": {
          "$ref": "#/$defs/DecisionKind",
          "default": "choice"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "model": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Gateway decision alias (default decide-default)",
          "title": "Model"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "on_low_confidence": {
          "$ref": "#/$defs/LowConfidence",
          "default": {
            "ask": {
              "approver_roles": [
                "approver"
              ],
              "label": null,
              "sla": "PT4H"
            },
            "route": null
          }
        },
        "options": {
          "default": [],
          "items": {
            "$ref": "#/$defs/DecisionOption"
          },
          "maxItems": 20,
          "title": "Options",
          "type": "array"
        },
        "output_key": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "State key; defaults to the node id",
          "title": "Output Key"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "question": {
          "$ref": "#/$defs/Text"
        },
        "rubric": {
          "anyOf": [
            {
              "$ref": "#/$defs/Rubric"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "threshold": {
          "default": 0.7,
          "maximum": 1,
          "minimum": 0,
          "title": "Threshold",
          "type": "number"
        },
        "type": {
          "const": "decision",
          "default": "decision",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "question"
      ],
      "title": "DecisionNode",
      "type": "object"
    },
    "DecisionOption": {
      "additionalProperties": false,
      "description": "One declared answer. ``value`` is what the model must pick and what edges match on.",
      "properties": {
        "description": {
          "anyOf": [
            {
              "maxLength": 500,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Shown to the decision model, not to users",
          "title": "Description"
        },
        "label": {
          "$ref": "#/$defs/Text"
        },
        "value": {
          "title": "Value",
          "type": "string"
        }
      },
      "required": [
        "value",
        "label"
      ],
      "title": "DecisionOption",
      "type": "object"
    },
    "Edge": {
      "additionalProperties": false,
      "properties": {
        "from": {
          "title": "From",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain words for the arrow, e.g. 'city not understood' (ADR-0071)"
        },
        "to": {
          "title": "To",
          "type": "string"
        },
        "when": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "When"
        }
      },
      "required": [
        "from",
        "to"
      ],
      "title": "Edge",
      "type": "object"
    },
    "EndNode": {
      "additionalProperties": false,
      "properties": {
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "type": {
          "const": "end",
          "default": "end",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id"
      ],
      "title": "EndNode",
      "type": "object"
    },
    "ForEachNode": {
      "additionalProperties": false,
      "description": "Do the same steps for every item of a list (ADR-0104): a sub-flow of this agent's own\nsteps (``steps``, the first is where each item starts) or another agent (``agent``). Each\nitem runs as its own child run (a Temporal child workflow, with its own policy checks and\naudit trail), at most ``concurrency`` at a time. The results are kept in the list's order\nunder ``output_key``: one ``{item, status, result, error}`` per item.",
      "properties": {
        "agent": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Another registered agent (name@version) done for each item",
          "title": "Agent"
        },
        "collect": {
          "anyOf": [
            {
              "maxLength": 300,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "What is kept from each item's run, as a state path inside it (e.g. 'draft_answer'). Unset: every value the steps made.",
          "title": "Collect"
        },
        "concurrency": {
          "default": 4,
          "maximum": 20,
          "minimum": 1,
          "title": "Concurrency",
          "type": "integer"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "item_key": {
          "default": "item",
          "description": "The name each item has inside the steps (state.item); item_number counts",
          "pattern": "^[A-Za-z_][A-Za-z0-9_]{0,63}$",
          "title": "Item Key",
          "type": "string"
        },
        "items": {
          "description": "The list, as a state path (e.g. 'list_invoices_result.rows')",
          "maxLength": 300,
          "minLength": 1,
          "title": "Items",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_cost_usd": {
          "anyOf": [
            {
              "exclusiveMinimum": 0,
              "maximum": 10000,
              "type": "number"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "The most all items together may cost; unset: what is left of the run's budget",
          "title": "Max Cost Usd"
        },
        "max_items": {
          "default": 100,
          "maximum": 500,
          "minimum": 1,
          "title": "Max Items",
          "type": "integer"
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_item_error": {
          "default": "skip",
          "description": "An item that fails: 'skip' records it and goes on, 'stop' starts no more items and fails the run, 'ask' asks a person to skip it, try it again or stop.",
          "enum": [
            "skip",
            "stop",
            "ask"
          ],
          "title": "On Item Error",
          "type": "string"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_key": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "State key; default <id>_results",
          "title": "Output Key"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "steps": {
          "anyOf": [
            {
              "items": {
                "type": "string"
              },
              "maxItems": 30,
              "type": "array"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "This agent's steps done for each item; the first is where each item starts. Arrows may join them to each other only. Unset: 'agent'.",
          "title": "Steps"
        },
        "type": {
          "const": "foreach",
          "default": "foreach",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "items"
      ],
      "title": "ForEachNode",
      "type": "object"
    },
    "FormBlock": {
      "additionalProperties": false,
      "properties": {
        "fields": {
          "items": {
            "$ref": "#/$defs/FormField"
          },
          "maxItems": 12,
          "minItems": 1,
          "title": "Fields",
          "type": "array"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "kind": {
          "const": "form",
          "default": "form",
          "title": "Kind",
          "type": "string"
        },
        "submit": {
          "anyOf": [
            {
              "$ref": "#/$defs/ReplyText"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "title": {
          "anyOf": [
            {
              "$ref": "#/$defs/ReplyText"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        }
      },
      "required": [
        "id",
        "fields"
      ],
      "title": "FormBlock",
      "type": "object"
    },
    "FormField": {
      "additionalProperties": false,
      "description": "One question of a form, with the answer kinds the builder uses elsewhere (text, number,\ndate, one of a list), whether it is required, and simple checks.",
      "properties": {
        "key": {
          "title": "Key",
          "type": "string"
        },
        "label": {
          "$ref": "#/$defs/ReplyText"
        },
        "max": {
          "anyOf": [
            {
              "type": "number"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max"
        },
        "max_length": {
          "anyOf": [
            {
              "maximum": 2000,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Length"
        },
        "min": {
          "anyOf": [
            {
              "type": "number"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Min"
        },
        "options": {
          "default": [],
          "items": {
            "type": "string"
          },
          "maxItems": 30,
          "title": "Options",
          "type": "array"
        },
        "required": {
          "default": false,
          "title": "Required",
          "type": "boolean"
        },
        "type": {
          "default": "text",
          "enum": [
            "text",
            "number",
            "date",
            "choice"
          ],
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "key",
        "label"
      ],
      "title": "FormField",
      "type": "object"
    },
    "Graph": {
      "additionalProperties": false,
      "properties": {
        "edges": {
          "default": [],
          "items": {
            "$ref": "#/$defs/Edge"
          },
          "title": "Edges",
          "type": "array"
        },
        "entry": {
          "title": "Entry",
          "type": "string"
        },
        "nodes": {
          "items": {
            "discriminator": {
              "mapping": {
                "calculate": "#/$defs/CalculateNode",
                "decision": "#/$defs/DecisionNode",
                "end": "#/$defs/EndNode",
                "foreach": "#/$defs/ForEachNode",
                "handover": "#/$defs/HandoverNode",
                "human_approval": "#/$defs/HumanApprovalNode",
                "human_input": "#/$defs/HumanInputNode",
                "join": "#/$defs/JoinNode",
                "llm": "#/$defs/LlmNode",
                "parallel": "#/$defs/ParallelNode",
                "python": "#/$defs/PythonNode",
                "retrieval": "#/$defs/RetrievalNode",
                "router": "#/$defs/RouterNode",
                "subgraph": "#/$defs/SubgraphNode",
                "table": "#/$defs/TableNode",
                "tool": "#/$defs/ToolNode",
                "wait": "#/$defs/WaitNode"
              },
              "propertyName": "type"
            },
            "oneOf": [
              {
                "$ref": "#/$defs/LlmNode"
              },
              {
                "$ref": "#/$defs/ToolNode"
              },
              {
                "$ref": "#/$defs/RouterNode"
              },
              {
                "$ref": "#/$defs/HumanApprovalNode"
              },
              {
                "$ref": "#/$defs/HumanInputNode"
              },
              {
                "$ref": "#/$defs/ParallelNode"
              },
              {
                "$ref": "#/$defs/JoinNode"
              },
              {
                "$ref": "#/$defs/SubgraphNode"
              },
              {
                "$ref": "#/$defs/RetrievalNode"
              },
              {
                "$ref": "#/$defs/PythonNode"
              },
              {
                "$ref": "#/$defs/DecisionNode"
              },
              {
                "$ref": "#/$defs/EndNode"
              },
              {
                "$ref": "#/$defs/WaitNode"
              },
              {
                "$ref": "#/$defs/CalculateNode"
              },
              {
                "$ref": "#/$defs/ForEachNode"
              },
              {
                "$ref": "#/$defs/TableNode"
              },
              {
                "$ref": "#/$defs/HandoverNode"
              }
            ]
          },
          "minItems": 1,
          "title": "Nodes",
          "type": "array"
        }
      },
      "required": [
        "entry",
        "nodes"
      ],
      "title": "Graph",
      "type": "object"
    },
    "HandoffAction": {
      "additionalProperties": false,
      "description": "Continue elsewhere and come back (ADR-0094): opens ``url`` (a template; shown only when\nits host is on the organisation's allow-list) with a one-time return link added as the\n``return_param`` query value. The run goes on to the ``wait`` step (\"Wait for\"), which ends\nwhen that link is opened (the person's browser or the other site's server).",
      "properties": {
        "return_param": {
          "default": "return_url",
          "pattern": "^[A-Za-z_][A-Za-z0-9_.-]{0,40}$",
          "title": "Return Param",
          "type": "string"
        },
        "type": {
          "const": "handoff",
          "default": "handoff",
          "title": "Type",
          "type": "string"
        },
        "url": {
          "maxLength": 2000,
          "minLength": 1,
          "title": "Url",
          "type": "string"
        },
        "wait": {
          "description": "The 'Wait for' step the run waits at",
          "minLength": 1,
          "title": "Wait",
          "type": "string"
        }
      },
      "required": [
        "url",
        "wait"
      ],
      "title": "HandoffAction",
      "type": "object"
    },
    "HandoverNode": {
      "additionalProperties": false,
      "description": "Hand the conversation to a person (G-camp-cs-02): on website chat, chat apps, e-mail\nand the other channels, the conversation goes to the team's desk (\"Needs you\") and the\nagent stops answering until a person hands it back. Elsewhere (the console, a webhook) the\nrun notes that a person was asked for and goes on.",
      "properties": {
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "reason": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Why a person should take over, shown to the desk, e.g. 'Wants a refund'"
        },
        "type": {
          "const": "handover",
          "default": "handover",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id"
      ],
      "title": "HandoverNode",
      "type": "object"
    },
    "HumanApprovalNode": {
      "additionalProperties": false,
      "properties": {
        "approver_roles": {
          "default": [
            "approver"
          ],
          "items": {
            "type": "string"
          },
          "title": "Approver Roles",
          "type": "array"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "escalate_to": {
          "anyOf": [
            {
              "items": {
                "type": "string"
              },
              "maxItems": 10,
              "type": "array"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Roles the request goes to, in order, when nobody decides within sla (a reminder half-way first). ADR-0097, ADR-0102",
          "title": "Escalate To"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "levels": {
          "anyOf": [
            {
              "items": {
                "$ref": "#/$defs/ApprovalLevel"
              },
              "type": "array"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "An approval chain (ADR-0102): levels signed in order by different people. Unset: one level by approver_roles",
          "title": "Levels"
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "on_reject": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "On Reject"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "sla": {
          "default": "PT4H",
          "format": "duration",
          "title": "Sla",
          "type": "string"
        },
        "sla_days": {
          "anyOf": [
            {
              "maximum": 60,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Time limit in the organisation's working days (instead of sla)",
          "title": "Sla Days"
        },
        "subject_key": {
          "description": "State key holding the intent to approve",
          "title": "Subject Key",
          "type": "string"
        },
        "type": {
          "const": "human_approval",
          "default": "human_approval",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "subject_key"
      ],
      "title": "HumanApprovalNode",
      "type": "object"
    },
    "HumanInputNode": {
      "additionalProperties": false,
      "properties": {
        "answer_schema": {
          "anyOf": [
            {
              "additionalProperties": true,
              "type": "object"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "JSON Schema of the person's answer (text, a number, yes/no or one of a list); drives the agent's data map (ADR-0071). Unset means text.",
          "title": "Answer Schema"
        },
        "approver_roles": {
          "anyOf": [
            {
              "items": {
                "type": "string"
              },
              "maxItems": 20,
              "type": "array"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Roles whose holders answer. Unset: the person who started the run answers (people with the 'approver' role when the run was not started by a person, e.g. a schedule). With roles, the person who started the run is never offered the question and may not answer it, unless requester_answers is true (G-camp-gov-10).",
          "title": "Approver Roles"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_key": {
          "title": "Output Key",
          "type": "string"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "question": {
          "$ref": "#/$defs/Text"
        },
        "requester_answers": {
          "anyOf": [
            {
              "type": "boolean"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "With approver_roles: the person who started the run may answer too. Off unless set.",
          "title": "Requester Answers"
        },
        "type": {
          "const": "human_input",
          "default": "human_input",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "question",
        "output_key"
      ],
      "title": "HumanInputNode",
      "type": "object"
    },
    "JoinNode": {
      "additionalProperties": false,
      "properties": {
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "strategy": {
          "default": "merge",
          "enum": [
            "merge",
            "list",
            "vote"
          ],
          "title": "Strategy",
          "type": "string"
        },
        "type": {
          "const": "join",
          "default": "join",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id"
      ],
      "title": "JoinNode",
      "type": "object"
    },
    "KnowledgeSource": {
      "additionalProperties": false,
      "properties": {
        "collection": {
          "title": "Collection",
          "type": "string"
        },
        "top_k": {
          "default": 8,
          "maximum": 50,
          "minimum": 1,
          "title": "Top K",
          "type": "integer"
        }
      },
      "required": [
        "collection"
      ],
      "title": "KnowledgeSource",
      "type": "object"
    },
    "LinkAction": {
      "additionalProperties": false,
      "description": "Opens a URL template filled from data. Shown only when its scheme and host are on the\norganisation's allow-list (same-origin console links ``/...`` always are).",
      "properties": {
        "type": {
          "const": "link",
          "default": "link",
          "title": "Type",
          "type": "string"
        },
        "url": {
          "maxLength": 2000,
          "minLength": 1,
          "title": "Url",
          "type": "string"
        }
      },
      "required": [
        "url"
      ],
      "title": "LinkAction",
      "type": "object"
    },
    "LinkBlock": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "title": "Id",
          "type": "string"
        },
        "kind": {
          "const": "link",
          "default": "link",
          "title": "Kind",
          "type": "string"
        },
        "label": {
          "$ref": "#/$defs/ReplyText"
        },
        "url": {
          "maxLength": 2000,
          "minLength": 1,
          "title": "Url",
          "type": "string"
        }
      },
      "required": [
        "id",
        "label",
        "url"
      ],
      "title": "LinkBlock",
      "type": "object"
    },
    "LlmNode": {
      "additionalProperties": false,
      "properties": {
        "add_to_list": {
          "anyOf": [
            {
              "pattern": "^[A-Za-z_][A-Za-z0-9_]*$",
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Also add each answer of this step to the list kept under this state key, so the answers of a step that runs again (a loop) add up instead of replacing each other. output_key still holds the latest answer.",
          "title": "Add To List"
        },
        "agents": {
          "anyOf": [
            {
              "items": {
                "type": "string"
              },
              "type": "array"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Team members the model may ask (a supervisor team, ADR-0093): each is offered as a function; the step that runs that member answers the call.",
          "title": "Agents"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "model": {
          "anyOf": [
            {
              "$ref": "#/$defs/ModelSettings"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "on_error": {
          "anyOf": [
            {
              "enum": [
                "fail",
                "continue"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "What a failed model call does (an error, the time limit, an unreadable or blocked structured answer). 'continue' stores {\"error\": reason} under output_key and the run goes on, so a later step can fall back. Unset means fail the run.",
          "title": "On Error"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_key": {
          "default": "messages",
          "title": "Output Key",
          "type": "string"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "prompt": {
          "$ref": "#/$defs/PromptRef"
        },
        "reply": {
          "anyOf": [
            {
              "$ref": "#/$defs/ReplyDesign"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Rich reply (ADR-0088): buttons, quick replies, cards, a table, a form or links shown with the text answer, filled from earlier steps. The text answer always carries a plain-text version for channels and history that show text only."
        },
        "show_results": {
          "anyOf": [
            {
              "enum": [
                "auto",
                "referenced",
                "off"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Systems' results shown with the answer (ADR-0116): the answer references a tool result ([[show:tool.action]]) and the screen draws the system's own data instead of the model retyping it. 'auto' also shows the results whose tool declares a display; 'referenced' only what the answer references; 'off' none. Unset means auto.",
          "title": "Show Results"
        },
        "timeout_s": {
          "anyOf": [
            {
              "maximum": 300,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Time limit for the model call, in seconds",
          "title": "Timeout S"
        },
        "tools": {
          "default": [],
          "description": "Tools the model may call (ReAct)",
          "items": {
            "type": "string"
          },
          "title": "Tools",
          "type": "array"
        },
        "type": {
          "const": "llm",
          "default": "llm",
          "title": "Type",
          "type": "string"
        },
        "use_attachments": {
          "anyOf": [
            {
              "type": "boolean"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Give the model the text of documents attached in the chat (ADR-0067), as an 'Attached documents' block before the question; prompts can place it themselves with {attachments}. Unset means yes.",
          "title": "Use Attachments"
        },
        "use_history": {
          "anyOf": [
            {
              "type": "boolean"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Give the model the earlier turns of the same chat conversation (ADR-0067), as prior chat messages built by the platform. Unset means yes.",
          "title": "Use History"
        },
        "use_step_results": {
          "anyOf": [
            {
              "type": "boolean"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Give the model the results of the earlier steps of this run (tool results and earlier model replies) as messages. Unset means yes; a step that only needs a few values passes them through prompt variables instead.",
          "title": "Use Step Results"
        }
      },
      "required": [
        "id",
        "prompt"
      ],
      "title": "LlmNode",
      "type": "object"
    },
    "LowConfidence": {
      "additionalProperties": false,
      "description": "What happens when the decision's probability is below the node's threshold: ask a\nperson, or continue at another node (e.g. a safe default path).",
      "properties": {
        "ask": {
          "anyOf": [
            {
              "$ref": "#/$defs/AskPerson"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "route": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Route"
        }
      },
      "title": "LowConfidence",
      "type": "object"
    },
    "Member": {
      "additionalProperties": false,
      "properties": {
        "agent": {
          "description": "A registered agent of the organisation: its name (the version released to the environment the team runs in) or name@version (that version)",
          "title": "Agent",
          "type": "string"
        },
        "can_handoff_to": {
          "default": [],
          "description": "Handoff teams: the members this one may hand the conversation to",
          "items": {
            "type": "string"
          },
          "title": "Can Handoff To",
          "type": "array"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "What the member is good at, in plain words. The supervisor (or the hand-over step) reads it to choose the member."
        },
        "role": {
          "$ref": "#/$defs/Text",
          "description": "The member's short name in the team, e.g. 'Billing'"
        }
      },
      "required": [
        "agent",
        "role"
      ],
      "title": "Member",
      "type": "object"
    },
    "MemoryScope": {
      "enum": [
        "working",
        "user",
        "agent",
        "tenant"
      ],
      "title": "MemoryScope",
      "type": "string"
    },
    "MemorySettings": {
      "additionalProperties": false,
      "properties": {
        "episodic": {
          "default": false,
          "title": "Episodic",
          "type": "boolean"
        },
        "retention_days": {
          "default": 30,
          "maximum": 3650,
          "minimum": 0,
          "title": "Retention Days",
          "type": "integer"
        },
        "scopes": {
          "default": [
            "working"
          ],
          "items": {
            "$ref": "#/$defs/MemoryScope"
          },
          "title": "Scopes",
          "type": "array"
        },
        "semantic": {
          "default": false,
          "title": "Semantic",
          "type": "boolean"
        }
      },
      "title": "MemorySettings",
      "type": "object"
    },
    "Metadata": {
      "additionalProperties": false,
      "properties": {
        "description": {
          "$ref": "#/$defs/Text"
        },
        "labels": {
          "additionalProperties": {
            "type": "string"
          },
          "default": {},
          "title": "Labels",
          "type": "object"
        },
        "name": {
          "title": "Name",
          "type": "string"
        },
        "owner": {
          "minLength": 1,
          "title": "Owner",
          "type": "string"
        },
        "tenant": {
          "title": "Tenant",
          "type": "string"
        },
        "version": {
          "title": "Version",
          "type": "string"
        }
      },
      "required": [
        "name",
        "tenant",
        "version",
        "owner",
        "description"
      ],
      "title": "Metadata",
      "type": "object"
    },
    "ModelSettings": {
      "additionalProperties": false,
      "properties": {
        "alias": {
          "description": "Gateway alias, never a provider model id",
          "minLength": 1,
          "title": "Alias",
          "type": "string"
        },
        "fallback_alias": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Fallback Alias"
        },
        "max_tokens": {
          "default": 2048,
          "maximum": 200000,
          "minimum": 1,
          "title": "Max Tokens",
          "type": "integer"
        },
        "output_schema": {
          "anyOf": [
            {
              "additionalProperties": true,
              "type": "object"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Output Schema"
        },
        "temperature": {
          "default": 0.2,
          "maximum": 2,
          "minimum": 0,
          "title": "Temperature",
          "type": "number"
        }
      },
      "required": [
        "alias"
      ],
      "title": "ModelSettings",
      "type": "object"
    },
    "ParallelNode": {
      "additionalProperties": false,
      "properties": {
        "branches": {
          "items": {
            "type": "string"
          },
          "minItems": 2,
          "title": "Branches",
          "type": "array"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "join": {
          "title": "Join",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "type": {
          "const": "parallel",
          "default": "parallel",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "branches",
        "join"
      ],
      "title": "ParallelNode",
      "type": "object"
    },
    "Pattern": {
      "enum": [
        "react",
        "plan_execute",
        "reflection",
        "router",
        "supervisor",
        "handoff",
        "debate",
        "hierarchical",
        "custom"
      ],
      "title": "Pattern",
      "type": "string"
    },
    "Permissions": {
      "additionalProperties": false,
      "properties": {
        "autonomous": {
          "default": false,
          "title": "Autonomous",
          "type": "boolean"
        },
        "channel_purposes": {
          "anyOf": [
            {
              "items": {
                "type": "string"
              },
              "maxItems": 20,
              "type": "array"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "What the agent may send people by e-mail, chat apps or SMS (the channels service's consent purposes, e.g. service.updates, appointment.reminders). Unset: service messages only (service.updates, case.updates, notifications). A message still needs the person's consent, except a service message to the person's own address about their own request (ADR-0109).",
          "title": "Channel Purposes"
        },
        "input_classification": {
          "anyOf": [
            {
              "$ref": "#/$defs/Classification"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "The data level of what people and other systems send this agent (the question, a channel message, a webhook's event). Each AI step's data level starts from it (ADR-0108). Empty: Internal for what a person types, the agent's own level for what another system sends. Never above max_classification."
        },
        "max_classification": {
          "$ref": "#/$defs/Classification",
          "default": "internal"
        },
        "runner_groups": {
          "default": [],
          "items": {
            "type": "string"
          },
          "title": "Runner Groups",
          "type": "array"
        }
      },
      "title": "Permissions",
      "type": "object"
    },
    "PromptRef": {
      "additionalProperties": false,
      "description": "A prompt from the registry (MLflow prompt registry, ADR-0014) or inline.",
      "properties": {
        "bindings": {
          "additionalProperties": {
            "type": "string"
          },
          "default": {},
          "description": "Saved prompts: which value each {{placeholder}} takes, as a state path (placeholder -> e.g. 'question' or 'think_result.answer'). A placeholder without a binding takes the state value of the same name.",
          "title": "Bindings",
          "type": "object"
        },
        "ref": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "e.g. prompts:/invoice-system@production",
          "title": "Ref"
        },
        "template": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Template"
        },
        "time_zone": {
          "anyOf": [
            {
              "maxLength": 64,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "IANA time zone (e.g. Asia/Dubai) of the {today}, {weekday} and {now} values the platform fills in when the prompt uses them. Unset means UTC.",
          "title": "Time Zone"
        },
        "variables": {
          "default": [],
          "items": {
            "type": "string"
          },
          "title": "Variables",
          "type": "array"
        }
      },
      "title": "PromptRef",
      "type": "object"
    },
    "PythonNode": {
      "additionalProperties": false,
      "properties": {
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "entrypoint": {
          "pattern": "^[a-zA-Z_][\\w.]*:[a-zA-Z_]\\w*$",
          "title": "Entrypoint",
          "type": "string"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "type": {
          "const": "python",
          "default": "python",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "entrypoint"
      ],
      "title": "PythonNode",
      "type": "object"
    },
    "QuickRepliesBlock": {
      "additionalProperties": false,
      "description": "Short answers the person can tap; ``ai_pick``: the AI model shows at most this many of\nthem, chosen for the conversation (never others).",
      "properties": {
        "ai_pick": {
          "anyOf": [
            {
              "maximum": 10,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Ai Pick"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "kind": {
          "const": "quick_replies",
          "default": "quick_replies",
          "title": "Kind",
          "type": "string"
        },
        "options": {
          "items": {
            "$ref": "#/$defs/Button"
          },
          "maxItems": 10,
          "minItems": 1,
          "title": "Options",
          "type": "array"
        }
      },
      "required": [
        "id",
        "options"
      ],
      "title": "QuickRepliesBlock",
      "type": "object"
    },
    "ReplyAction": {
      "additionalProperties": false,
      "description": "Sends ``value`` (a template; unset: the button's label) as the person's message.",
      "properties": {
        "type": {
          "const": "reply",
          "default": "reply",
          "title": "Type",
          "type": "string"
        },
        "value": {
          "anyOf": [
            {
              "maxLength": 500,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Value"
        }
      },
      "title": "ReplyAction",
      "type": "object"
    },
    "ReplyDesign": {
      "additionalProperties": false,
      "description": "What an AI step shows besides its text answer (ADR-0088).",
      "properties": {
        "blocks": {
          "items": {
            "discriminator": {
              "mapping": {
                "buttons": "#/$defs/ButtonsBlock",
                "cards": "#/$defs/CardsBlock",
                "form": "#/$defs/FormBlock",
                "link": "#/$defs/LinkBlock",
                "quick_replies": "#/$defs/QuickRepliesBlock",
                "table": "#/$defs/TableBlock",
                "text": "#/$defs/TextBlock"
              },
              "propertyName": "kind"
            },
            "oneOf": [
              {
                "$ref": "#/$defs/TextBlock"
              },
              {
                "$ref": "#/$defs/QuickRepliesBlock"
              },
              {
                "$ref": "#/$defs/ButtonsBlock"
              },
              {
                "$ref": "#/$defs/FormBlock"
              },
              {
                "$ref": "#/$defs/CardsBlock"
              },
              {
                "$ref": "#/$defs/TableBlock"
              },
              {
                "$ref": "#/$defs/LinkBlock"
              }
            ]
          },
          "maxItems": 12,
          "minItems": 1,
          "title": "Blocks",
          "type": "array"
        }
      },
      "required": [
        "blocks"
      ],
      "title": "ReplyDesign",
      "type": "object"
    },
    "ReplyText": {
      "additionalProperties": false,
      "description": "Bilingual text with placeholders. One language may be left empty: the other is shown.",
      "properties": {
        "ar": {
          "default": "",
          "maxLength": 2000,
          "title": "Ar",
          "type": "string"
        },
        "en": {
          "default": "",
          "maxLength": 2000,
          "title": "En",
          "type": "string"
        }
      },
      "title": "ReplyText",
      "type": "object"
    },
    "RetrievalNode": {
      "additionalProperties": false,
      "properties": {
        "collection": {
          "title": "Collection",
          "type": "string"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_key": {
          "default": "context",
          "title": "Output Key",
          "type": "string"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "query": {
          "default": "{{ state.question }}",
          "title": "Query",
          "type": "string"
        },
        "type": {
          "const": "retrieval",
          "default": "retrieval",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "collection"
      ],
      "title": "RetrievalNode",
      "type": "object"
    },
    "RiskTier": {
      "enum": [
        1,
        2,
        3,
        4
      ],
      "title": "RiskTier",
      "type": "integer"
    },
    "Route": {
      "additionalProperties": false,
      "properties": {
        "to": {
          "title": "To",
          "type": "string"
        },
        "when": {
          "title": "When",
          "type": "string"
        }
      },
      "required": [
        "when",
        "to"
      ],
      "title": "Route",
      "type": "object"
    },
    "RouterNode": {
      "additionalProperties": false,
      "properties": {
        "default": {
          "title": "Default",
          "type": "string"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "routes": {
          "items": {
            "$ref": "#/$defs/Route"
          },
          "title": "Routes",
          "type": "array"
        },
        "type": {
          "const": "router",
          "default": "router",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "routes",
        "default"
      ],
      "title": "RouterNode",
      "type": "object"
    },
    "Rubric": {
      "additionalProperties": false,
      "description": "A score on ``min..max``; the model chooses among the anchors and the answer is the\nexpected value over them.",
      "properties": {
        "anchors": {
          "items": {
            "$ref": "#/$defs/RubricAnchor"
          },
          "maxItems": 20,
          "minItems": 2,
          "title": "Anchors",
          "type": "array"
        },
        "max": {
          "title": "Max",
          "type": "integer"
        },
        "min": {
          "title": "Min",
          "type": "integer"
        }
      },
      "required": [
        "min",
        "max",
        "anchors"
      ],
      "title": "Rubric",
      "type": "object"
    },
    "RubricAnchor": {
      "additionalProperties": false,
      "properties": {
        "description": {
          "anyOf": [
            {
              "maxLength": 500,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Description"
        },
        "label": {
          "$ref": "#/$defs/Text"
        },
        "value": {
          "title": "Value",
          "type": "integer"
        }
      },
      "required": [
        "value",
        "label"
      ],
      "title": "RubricAnchor",
      "type": "object"
    },
    "Spec": {
      "additionalProperties": false,
      "properties": {
        "a2a": {
          "$ref": "#/$defs/A2ASettings",
          "default": {
            "publish_card": false,
            "skills": []
          }
        },
        "approvals": {
          "default": [],
          "items": {
            "$ref": "#/$defs/ApprovalRule"
          },
          "title": "Approvals",
          "type": "array"
        },
        "budgets": {
          "$ref": "#/$defs/Budgets",
          "default": {
            "max_cost_usd": 1.0,
            "max_steps": 25,
            "max_tokens": 100000,
            "timeout": "PT10M"
          }
        },
        "builder_profile": {
          "$ref": "#/$defs/BuilderProfile",
          "default": "code"
        },
        "channels": {
          "default": [
            "web",
            "api"
          ],
          "items": {
            "$ref": "#/$defs/Channel"
          },
          "title": "Channels",
          "type": "array"
        },
        "constraints": {
          "default": [],
          "items": {
            "$ref": "#/$defs/Text"
          },
          "title": "Constraints",
          "type": "array"
        },
        "files": {
          "additionalProperties": {
            "type": "string"
          },
          "default": {},
          "description": "Agent files (ADR-0071): code and scripts stored once and used by steps as {\"$file\": \"<name>\"}. Left out of the document while empty.",
          "title": "Files",
          "type": "object"
        },
        "goals": {
          "items": {
            "$ref": "#/$defs/Text"
          },
          "minItems": 1,
          "title": "Goals",
          "type": "array"
        },
        "graph": {
          "$ref": "#/$defs/Graph"
        },
        "knowledge": {
          "default": [],
          "items": {
            "$ref": "#/$defs/KnowledgeSource"
          },
          "title": "Knowledge",
          "type": "array"
        },
        "memory": {
          "$ref": "#/$defs/MemorySettings",
          "default": {
            "episodic": false,
            "retention_days": 30,
            "scopes": [
              "working"
            ],
            "semantic": false
          }
        },
        "model": {
          "$ref": "#/$defs/ModelSettings"
        },
        "pattern": {
          "$ref": "#/$defs/Pattern"
        },
        "permissions": {
          "$ref": "#/$defs/Permissions",
          "default": {
            "autonomous": false,
            "max_classification": "internal",
            "runner_groups": []
          }
        },
        "risk_tier": {
          "$ref": "#/$defs/RiskTier"
        },
        "role": {
          "$ref": "#/$defs/Text"
        },
        "tools": {
          "default": [],
          "items": {
            "$ref": "#/$defs/ToolGrant"
          },
          "title": "Tools",
          "type": "array"
        },
        "topology": {
          "anyOf": [
            {
              "$ref": "#/$defs/Topology"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "triggers": {
          "default": [
            {
              "config": {},
              "type": "manual"
            }
          ],
          "items": {
            "$ref": "#/$defs/Trigger"
          },
          "title": "Triggers",
          "type": "array"
        }
      },
      "required": [
        "role",
        "goals",
        "pattern",
        "model",
        "risk_tier",
        "graph"
      ],
      "title": "Spec",
      "type": "object"
    },
    "StepAction": {
      "additionalProperties": false,
      "description": "Runs a \"Use a system\" step of the same agent: the run goes on along this button's path.",
      "properties": {
        "step": {
          "minLength": 1,
          "title": "Step",
          "type": "string"
        },
        "type": {
          "const": "action",
          "default": "action",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "step"
      ],
      "title": "StepAction",
      "type": "object"
    },
    "SubgraphNode": {
      "additionalProperties": false,
      "properties": {
        "agent": {
          "description": "name@version of another registered agent; a team member's step may name the agent only (the version released to the environment the team runs in, ADR-0093)",
          "title": "Agent",
          "type": "string"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "input_map": {
          "additionalProperties": {
            "type": "string"
          },
          "default": {},
          "title": "Input Map",
          "type": "object"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_key": {
          "default": "subgraph_result",
          "title": "Output Key",
          "type": "string"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "type": {
          "const": "subgraph",
          "default": "subgraph",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "agent"
      ],
      "title": "SubgraphNode",
      "type": "object"
    },
    "TableBlock": {
      "additionalProperties": false,
      "properties": {
        "columns": {
          "items": {
            "$ref": "#/$defs/TableColumn"
          },
          "maxItems": 8,
          "minItems": 1,
          "title": "Columns",
          "type": "array"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "items": {
          "title": "Items",
          "type": "string"
        },
        "kind": {
          "const": "table",
          "default": "table",
          "title": "Kind",
          "type": "string"
        },
        "max": {
          "default": 20,
          "maximum": 50,
          "minimum": 1,
          "title": "Max",
          "type": "integer"
        }
      },
      "required": [
        "id",
        "items",
        "columns"
      ],
      "title": "TableBlock",
      "type": "object"
    },
    "TableColumn": {
      "additionalProperties": false,
      "properties": {
        "label": {
          "$ref": "#/$defs/ReplyText"
        },
        "value": {
          "maxLength": 500,
          "minLength": 1,
          "title": "Value",
          "type": "string"
        }
      },
      "required": [
        "label",
        "value"
      ],
      "title": "TableColumn",
      "type": "object"
    },
    "TableKey": {
      "additionalProperties": false,
      "description": "A column pair two tables are matched on (ADR-0105).",
      "properties": {
        "left": {
          "maxLength": 200,
          "minLength": 1,
          "title": "Left",
          "type": "string"
        },
        "right": {
          "maxLength": 200,
          "minLength": 1,
          "title": "Right",
          "type": "string"
        },
        "tolerance": {
          "anyOf": [
            {
              "pattern": "^\\s*[0-9]+(\\.[0-9]+)?\\s*(%|d|day|days)?\\s*$",
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Unset: the same value; else an amount (0.01), a percentage (2%) or 3 days",
          "title": "Tolerance"
        }
      },
      "required": [
        "left",
        "right"
      ],
      "title": "TableKey",
      "type": "object"
    },
    "TableMeasure": {
      "additionalProperties": false,
      "description": "A total of each group (ADR-0105).",
      "properties": {
        "column": {
          "anyOf": [
            {
              "maxLength": 200,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Column"
        },
        "fn": {
          "enum": [
            "sum",
            "count",
            "avg",
            "min",
            "max"
          ],
          "title": "Fn",
          "type": "string"
        },
        "name": {
          "pattern": "^[A-Za-z_][A-Za-z0-9_ ]{0,63}$",
          "title": "Name",
          "type": "string"
        }
      },
      "required": [
        "fn",
        "name"
      ],
      "title": "TableMeasure",
      "type": "object"
    },
    "TableNode": {
      "additionalProperties": false,
      "description": "Table work without AI or code (ADR-0105): ``read`` a spreadsheet or CSV (an attached file,\nor text or rows from earlier steps) as rows; ``match`` two tables on columns with tolerances\n(matched pairs and what is left on each side); ``group`` rows with totals.",
      "properties": {
        "by": {
          "anyOf": [
            {
              "items": {
                "type": "string"
              },
              "maxItems": 10,
              "type": "array"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "group: the columns",
          "title": "By"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "document": {
          "anyOf": [
            {
              "maxLength": 200,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "read: part of the attached file's name",
          "title": "Document"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "keys": {
          "anyOf": [
            {
              "items": {
                "$ref": "#/$defs/TableKey"
              },
              "maxItems": 10,
              "type": "array"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Keys"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "left": {
          "anyOf": [
            {
              "maxLength": 300,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "match: the first table",
          "title": "Left"
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "measures": {
          "anyOf": [
            {
              "items": {
                "$ref": "#/$defs/TableMeasure"
              },
              "maxItems": 20,
              "type": "array"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Measures"
        },
        "mode": {
          "anyOf": [
            {
              "enum": [
                "one_to_one",
                "one_to_many"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Mode"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "op": {
          "enum": [
            "read",
            "match",
            "group"
          ],
          "title": "Op",
          "type": "string"
        },
        "output_key": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "State key; default <id>_table",
          "title": "Output Key"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "right": {
          "anyOf": [
            {
              "maxLength": 300,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "match: the second table",
          "title": "Right"
        },
        "sheet": {
          "anyOf": [
            {
              "maxLength": 200,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "read: the sheet's name",
          "title": "Sheet"
        },
        "source": {
          "anyOf": [
            {
              "maxLength": 300,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "read/group: the state path of the rows or CSV text; read unset: attached file",
          "title": "Source"
        },
        "type": {
          "const": "table",
          "default": "table",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "op"
      ],
      "title": "TableNode",
      "type": "object"
    },
    "Text": {
      "additionalProperties": false,
      "description": "Bilingual text. English and Arabic are both required (RTL-first, brief \u00a77).",
      "properties": {
        "ar": {
          "minLength": 1,
          "title": "Ar",
          "type": "string"
        },
        "en": {
          "minLength": 1,
          "title": "En",
          "type": "string"
        }
      },
      "required": [
        "en",
        "ar"
      ],
      "title": "Text",
      "type": "object"
    },
    "TextBlock": {
      "additionalProperties": false,
      "properties": {
        "id": {
          "title": "Id",
          "type": "string"
        },
        "kind": {
          "const": "text",
          "default": "text",
          "title": "Kind",
          "type": "string"
        },
        "text": {
          "$ref": "#/$defs/ReplyText"
        }
      },
      "required": [
        "id",
        "text"
      ],
      "title": "TextBlock",
      "type": "object"
    },
    "ToolGrant": {
      "additionalProperties": false,
      "properties": {
        "actions": {
          "items": {
            "type": "string"
          },
          "minItems": 1,
          "title": "Actions",
          "type": "array"
        },
        "dry_run": {
          "default": false,
          "title": "Dry Run",
          "type": "boolean"
        },
        "ref": {
          "description": "Tool registry name",
          "minLength": 1,
          "title": "Ref",
          "type": "string"
        },
        "version": {
          "default": "*",
          "description": "Version constraint",
          "title": "Version",
          "type": "string"
        }
      },
      "required": [
        "ref",
        "actions"
      ],
      "title": "ToolGrant",
      "type": "object"
    },
    "ToolNode": {
      "additionalProperties": false,
      "properties": {
        "action": {
          "title": "Action",
          "type": "string"
        },
        "args": {
          "additionalProperties": true,
          "default": {},
          "title": "Args",
          "type": "object"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_error": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "The step to go to when the call still fails (ADR-0079). Its {\"error\": reason} is kept under output_key either way. Unset (ADR-0100): when the action changes data and the call failed, was refused or was rejected, this path stops and the person is told; a step that only reads, or that runs an AI model's own call, goes on along the usual arrows.",
          "title": "On Error"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_field": {
          "anyOf": [
            {
              "pattern": "^[A-Za-z_][A-Za-z0-9_]{0,63}$",
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Keep only this field of the tool's result under output_key (e.g. the 'result' of a Code runner step). Missing field: null. Unset keeps the whole result.",
          "title": "Output Field"
        },
        "output_key": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Output Key"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "output_schema": {
          "anyOf": [
            {
              "additionalProperties": true,
              "type": "object"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "JSON Schema of what this step keeps (after output_field), declared by the developer or captured from a test run; overrides the tool manifest's output_schema in the agent's data map (ADR-0071). Not enforced at run time.",
          "title": "Output Schema"
        },
        "retries": {
          "anyOf": [
            {
              "maximum": 3,
              "minimum": 0,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "How many more times a failed call is tried (waiting 2, 4, 8 seconds). A call the rules refused or a person rejected is not tried again. Unset means 0.",
          "title": "Retries"
        },
        "tool": {
          "title": "Tool",
          "type": "string"
        },
        "type": {
          "const": "tool",
          "default": "tool",
          "title": "Type",
          "type": "string"
        }
      },
      "required": [
        "id",
        "tool",
        "action"
      ],
      "title": "ToolNode",
      "type": "object"
    },
    "Topology": {
      "additionalProperties": false,
      "properties": {
        "judge": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "No longer used (debate teams); kept so older files load",
          "title": "Judge"
        },
        "kind": {
          "$ref": "#/$defs/TopologyKind"
        },
        "max_rounds": {
          "default": 6,
          "description": "Supervisor teams: the most member calls for one request (then the answers are combined). Handoff teams: the most hand-overs for one request.",
          "maximum": 50,
          "minimum": 1,
          "title": "Max Rounds",
          "type": "integer"
        },
        "members": {
          "items": {
            "$ref": "#/$defs/Member"
          },
          "minItems": 2,
          "title": "Members",
          "type": "array"
        },
        "together": {
          "default": false,
          "description": "Supervisor teams: ask every member at once (in parallel) and combine their answers, instead of the supervisor asking them in turn",
          "title": "Together",
          "type": "boolean"
        }
      },
      "required": [
        "kind",
        "members"
      ],
      "title": "Topology",
      "type": "object"
    },
    "TopologyKind": {
      "description": "How a team of agents works (ADR-0093).\n\n``supervisor``: a supervisor AI asks the members (each a released agent) and combines their\nanswers. ``handoff``: one member helps at a time and may hand the conversation to another.\n``hierarchical`` is kept so older agent files still load: it works as ``supervisor`` (a\nmember may itself be a team). ``debate`` is no longer offered: older files still load, the\nteam setting has no effect and the Builder offers to remove it.",
      "enum": [
        "supervisor",
        "handoff",
        "debate",
        "hierarchical"
      ],
      "title": "TopologyKind",
      "type": "string"
    },
    "Trigger": {
      "additionalProperties": false,
      "properties": {
        "config": {
          "additionalProperties": true,
          "default": {},
          "title": "Config",
          "type": "object"
        },
        "type": {
          "$ref": "#/$defs/TriggerType"
        }
      },
      "required": [
        "type"
      ],
      "title": "Trigger",
      "type": "object"
    },
    "TriggerType": {
      "enum": [
        "webhook",
        "cron",
        "queue",
        "file_drop",
        "message",
        "email",
        "manual"
      ],
      "title": "TriggerType",
      "type": "string"
    },
    "WaitAnswer": {
      "additionalProperties": false,
      "description": "A person (or a system through the inbox) may answer instead: an input task.",
      "properties": {
        "answer_schema": {
          "anyOf": [
            {
              "additionalProperties": true,
              "type": "object"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Answer Schema"
        },
        "approver_roles": {
          "anyOf": [
            {
              "items": {
                "type": "string"
              },
              "maxItems": 20,
              "type": "array"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Roles whose holders answer. Unset: the person who started the run answers. With roles, that person is never offered the question unless requester_answers is true.",
          "title": "Approver Roles"
        },
        "question": {
          "$ref": "#/$defs/Text"
        },
        "requester_answers": {
          "anyOf": [
            {
              "type": "boolean"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "With approver_roles: the person who started the run may answer too. Off unless set.",
          "title": "Requester Answers"
        }
      },
      "required": [
        "question"
      ],
      "title": "WaitAnswer",
      "type": "object"
    },
    "WaitEvent": {
      "additionalProperties": false,
      "description": "An event another system sends to the platform's signed event address\n(``POST /v1/events/{tenant}/{agent}``, signed like the agent's webhook).",
      "properties": {
        "data_schema": {
          "anyOf": [
            {
              "additionalProperties": true,
              "type": "object"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "JSON Schema of the event's 'data', for the agent's data map (ADR-0071)",
          "title": "Data Schema"
        },
        "key": {
          "description": "Which event belongs to this run: a {{ state.path }} template (e.g. the order id) filled when the wait starts; the event's 'key' must be the same value",
          "maxLength": 500,
          "minLength": 1,
          "title": "Key",
          "type": "string"
        },
        "name": {
          "description": "The event's name, e.g. 'payment.received'",
          "title": "Name",
          "type": "string"
        }
      },
      "required": [
        "name",
        "key"
      ],
      "title": "WaitEvent",
      "type": "object"
    },
    "WaitNode": {
      "additionalProperties": false,
      "description": "Wait for something outside the run (ADR-0094): an event from another system, a time,\na person's answer, or the person coming back from a page a \"continue elsewhere\" button\nopened, whichever comes first. The run holds no worker while it waits (a Temporal timer\nand signals). Nothing by the give-up time: the run goes to ``on_give_up`` (or along the\nusual arrows). ``state.<output_key>`` says what ended the wait and carries its values.",
      "properties": {
        "after": {
          "anyOf": [
            {
              "format": "duration",
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Go on after this long (a time passing)",
          "title": "After"
        },
        "answer": {
          "anyOf": [
            {
              "$ref": "#/$defs/WaitAnswer"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "at": {
          "anyOf": [
            {
              "maxLength": 500,
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Go on at this date and time: ISO 8601 or a {{ state.path }} template",
          "title": "At"
        },
        "description": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "One line of what the step does, in plain words (ADR-0071)"
        },
        "event": {
          "anyOf": [
            {
              "$ref": "#/$defs/WaitEvent"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "give_up_after": {
          "anyOf": [
            {
              "format": "duration",
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Stop waiting after this long (default 30 days)",
          "title": "Give Up After"
        },
        "id": {
          "title": "Id",
          "type": "string"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null
        },
        "max_iterations": {
          "anyOf": [
            {
              "maximum": 100,
              "minimum": 1,
              "type": "integer"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "title": "Max Iterations"
        },
        "on_give_up": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "The step to go to when nothing came in time; unset: the usual arrows",
          "title": "On Give Up"
        },
        "on_limit": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Where the run goes when this step has run max_iterations times and is reached again (e.g. a step that answers with the last draft). Unset: the run stops with a plain message, keeping the last answer it gave.",
          "title": "On Limit"
        },
        "output_key": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "State key; default <id>_result",
          "title": "Output Key"
        },
        "output_label": {
          "anyOf": [
            {
              "$ref": "#/$defs/Text"
            },
            {
              "type": "null"
            }
          ],
          "default": null,
          "description": "Plain name of what the step makes, e.g. 'The request' (ADR-0071)"
        },
        "type": {
          "const": "wait",
          "default": "wait",
          "title": "Type",
          "type": "string"
        },
        "working_time": {
          "default": false,
          "description": "Count 'after' and 'give_up_after' in the organisation's working hours (the business calendar), e.g. 2 hours on a Thursday afternoon may end on Sunday",
          "title": "Working Time",
          "type": "boolean"
        }
      },
      "required": [
        "id"
      ],
      "title": "WaitNode",
      "type": "object"
    }
  },
  "additionalProperties": false,
  "properties": {
    "apiVersion": {
      "const": "agents.t-ceratops.io/v1",
      "default": "agents.t-ceratops.io/v1",
      "title": "Apiversion",
      "type": "string"
    },
    "kind": {
      "const": "Agent",
      "default": "Agent",
      "title": "Kind",
      "type": "string"
    },
    "metadata": {
      "$ref": "#/$defs/Metadata"
    },
    "spec": {
      "$ref": "#/$defs/Spec"
    }
  },
  "required": [
    "metadata",
    "spec"
  ],
  "title": "AgentSpec",
  "type": "object"
}
